import * as React from 'react';
import {
  IconChildPlayground16,
  IconPet16,
  IconFastService16,
  IconFitness16,
  IconOffice16,
  IconHospital16,
  IconPool16,
  IconRestaurant16,
  IconSpa16,
  IconSupermarket16,
  IconParking16,
  IconBarrier16,
  IconSecurity16,
  IconReception16,
  IconSecurityParking16,
  IconCloseArea16,
  IconSchool16,
  IconCommercialObject16,
  IconKid16,
  IconSportsground16,
  IconFireExtinguisher16,
  IconSignal16,
  IconOutdoorCamera16,
} from '@cian/ui-kit/icons';
import { EShortInfraType, EParkingType, ESecutiryType } from '../types/newbuilding/specificationsDetailed';

export const DETAILED_SPECIFICATIONS_ICON_MAP: { [id: string]: React.ReactNode } = {
  [EShortInfraType.Children]: <IconChildPlayground16 />,
  [EShortInfraType.Commerce]: <IconCommercialObject16 />,
  [EShortInfraType.Dogs]: <IconPet16 />,
  [EShortInfraType.Domestic]: <IconFastService16 />,
  [EShortInfraType.Fitness]: <IconFitness16 />,
  [EShortInfraType.Kindergarten]: <IconKid16 />,
  [EShortInfraType.Offices]: <IconOffice16 />,
  [EShortInfraType.Polyclinic]: <IconHospital16 />,
  [EShortInfraType.Pool]: <IconPool16 />,
  [EShortInfraType.Recreation]: <IconChildPlayground16 />, //
  [EShortInfraType.Restaurant]: <IconRestaurant16 />,
  [EShortInfraType.School]: <IconSchool16 />,
  [EShortInfraType.Spa]: <IconSpa16 />,
  [EShortInfraType.Sport]: <IconSportsground16 />,
  [EShortInfraType.Supermarket]: <IconSupermarket16 />,
  [EParkingType.Guest]: <IconParking16 />,
  [EParkingType.Standalone]: <IconParking16 />,
  [EParkingType.Underground]: <IconParking16 />,
  [ESecutiryType.Access]: <IconBarrier16 />,
  [ESecutiryType.AroundTheClock]: <IconSecurity16 />,
  [ESecutiryType.Camera]: <IconOutdoorCamera16 />,
  [ESecutiryType.Concierge]: <IconReception16 />,
  [ESecutiryType.Fire]: <IconFireExtinguisher16 />,
  [ESecutiryType.Parking]: <IconSecurityParking16 />,
  [ESecutiryType.Perimetr]: <IconCloseArea16 />,
  [ESecutiryType.Signal]: <IconSignal16 />,
};
